import axios from 'axios';
import { getAuth } from 'firebase/auth';

const API_BASE_URL = '/.netlify/functions';

async function getIdToken() {
  const auth = getAuth();
  const user = auth.currentUser;
  if (!user) throw new Error('Użytkownik nie jest zalogowany');
  return user.getIdToken(true);
}

export const fetchDietSuggestions = async (dietData) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-diet-suggestions`,
      dietData,
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching diet suggestions:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania planu diety. Spróbuj ponownie później.'
    );
  }
};

export const fetchDietDetails = async (detailsData) => {
  const idToken = await getIdToken();
  try {
    const response = await axios.post(
      `${API_BASE_URL}/fetch-diet-details`,
      detailsData,
      { headers: { Authorization: `Bearer ${idToken}` } }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching diet details:', error.message);
    throw new Error(
      'Wystąpił błąd podczas generowania szczegółów diety. Spróbuj ponownie później.'
    );
  }
}; 